import React from 'react'
import Offcanvas from 'react-bootstrap/Offcanvas'
import { Button } from 'components/Button'
import { useState } from 'react'
import { HeaderSignupButton, NavLink, OffcanvasMenusBox, OffcanvasMenusLink, OffcanvasMobileBackgroundWidth, OffcanvasMobileBody, PrimaryHeaderLogo } from '../HeaderStyled';
import { HeaderMenus } from '../HeaderContent'
import { FlexComponentCenter, FlexComponentSpaceBetween } from 'components/Box/AllFlexComponentStyle';
import { Link } from "react-router-dom"
import { ReactComponent as GamesFiLogo } from 'assets/Logo/headerLogo.svg'

function OffCanvasMenuItems({ name, ...props }) {

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    return (
        <>
            <FlexComponentSpaceBetween>

                <Button style={{ backgroundColor: 'rgba(14,14,44,0.4)', borderRadius: '0px' }} onClick={handleShow}>
                    {
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M4 6H20" stroke="#CD63FF" strokeWidth="2" strokeLinecap="square" />
                            <path d="M4 12H20" stroke="#CD63FF" strokeWidth="2" strokeLinecap="square" />
                            <path d="M4 18H20" stroke="#CD63FF" strokeWidth="2" strokeLinecap="square" />
                        </svg>
                    }
                </Button>

                {/* <NavLink to='/login'>
                    <HeaderSignupButton>LOGIN</HeaderSignupButton>
                </NavLink> */}

            </FlexComponentSpaceBetween>

            <OffcanvasMobileBackgroundWidth show={show} onHide={handleClose} {...props}>

                <Offcanvas.Header closeButton>
                    <Offcanvas.Title />
                </Offcanvas.Header>

                <Offcanvas.Body>
                    <OffcanvasMobileBody>
                        <FlexComponentCenter>
                            <PrimaryHeaderLogo>
                                <Link to='/'>
                                    <GamesFiLogo />
                                </Link>
                            </PrimaryHeaderLogo>
                        </FlexComponentCenter>

                        <OffcanvasMenusBox>
                            {
                                HeaderMenus.map((HeaderMenus) => (
                                    <OffcanvasMenusLink to={HeaderMenus.url} key={HeaderMenus.id}>
                                        {HeaderMenus.title}
                                    </OffcanvasMenusLink>
                                ))
                            }

                            <OffcanvasMenusLink to='/login'>Login / Signup</OffcanvasMenusLink>
                            {/* <OffcanvasMenusLink to='/signup'>Signup</OffcanvasMenusLink> */}

                        </OffcanvasMenusBox>

                    </OffcanvasMobileBody>
                </Offcanvas.Body>

            </OffcanvasMobileBackgroundWidth>
        </>
    );
}

const OffCanvasMobile: React.FC = () => {

    const OffCanvasMobileMenu: React.FC = () => {
        return (
            <>
                {['start'].map((placement, idx) => (
                    <OffCanvasMenuItems key={idx} placement={placement} name={placement} />
                ))}
            </>
        );
    }

    return (
        <>
            <OffCanvasMobileMenu />
        </>
    )
}

export default OffCanvasMobile;